export interface CatalogoInvestigador{
    value: string,
    label: string,
    email: string,
}

export function VoidCatalogoInvestigador():CatalogoInvestigador{
    return{
        value: '',
        label: '',
        email: '',
    }    
}